export const Types = {
  error: 'error',
  info: 'info',
  infoGray: 'infoGray',
};
